<script lang="ts" setup>
import Loader from "@/components/Loader.vue";

defineOptions({
  name: 'DemoApp'
});

window.appConfig = {
  apiEndpoint: import.meta.env.VITE_API_URL || 'localhost:44363',
  authenticationApiEndpoint: '',
  localization: 'EE',
  product: 'PALK',
};

</script>

<template>
  <div>
    <loader size="s" text="Palun oodake laen andmeid ... "/>
  </div>
</template>

<style scoped>
div {
  height: 200px;
  position: relative;
}
</style>
